import { z } from "zod";

const machineStatuses = [
	"AirplaneMode",
	"Calibrating",
	"ChangingCorrugate",
	"ConnectingToMachine",
	"Disabled",
	"EmergencyStop",
	"Error",
	"Idle",
	"Initializing",
	"LightBarrierBroken",
	"Offline",
	"Online",
	"Paused",
	"Service Mode",
	"Service",
	"Unknown",
] as const;

export const machineStatusSchema = z.enum(machineStatuses);

export type MachineStatus = z.infer<typeof machineStatusSchema>;
